// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieInformation_root__PfjWG","info":"CookieInformation_info__3Jvsm","layout":"CookieInformation_layout__2Fx0o"};